/**
 * Типизированные хуки для работы с Redux
 * 
 * Отвечает за:
 * - Типизацию хуков useDispatch и useSelector
 * - Экспорт типизированных хуков для использования в компонентах
 */
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '../store';

/**
 * Типизированный хук useDispatch
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/**
 * Типизированный хук useSelector
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Реэкспорт хуков, связанных с Redux
export { useLanguage } from './useLanguage';
export { useBonusVideos } from './useBonusVideos';
export { useTrainings } from './useTrainings';
export { useFreeVideo } from './useFreeVideo';
export { useInstruction } from './useInstruction';
export { usePresentation } from './usePresentation';
export { useBeforeAfter } from './useBeforeAfter';
export { useNotifications } from './useNotifications'; 